import React from 'react'
import { Button, Header, Icon, Message, Segment } from 'semantic-ui-react'
import { Link } from 'react-router-dom'

import ClientsList from './ClientsList'
import BottomButtons from '../../Shared/BottomButtons'

const usageTip = `Luomalla asiakkaan voit linkittää sen kiinteistöön "Kohteet" osiosta. 
Kun tämä on tehty, alta löytyvän jaettavan linkin avulla kohteita voi seurata ilman 
kirjautumista järjestelmään.`

const Clients = () => {
    return (
        <div>
            <Header as="h2">Listaus asiakkaista</Header>

            <Message info icon="idea" content={usageTip} />

            <Segment size="large">

                <ClientsList />

                <BottomButtons>
                    <Button primary as={Link} to="/admin/">
                        <Icon name="arrow left" />
                        Takaisin
                </Button>

                    <Button positive as={Link} to="/admin/asiakkaat/uusi">
                        <Icon name="add user" />
                        Luo uusi
                </Button>
                </BottomButtons>

            </Segment>


        </div>
    )
}

export default Clients


// WEBPACK FOOTER //
// ./src/Admin/Clients/Clients.js